import EmployeeSetupPage from "./EmployeeSetupPage";

export default EmployeeSetupPage;
